import { gql } from '@apollo/client';
import { AD_BASE_FIELDS } from '@/api/queries/ads.queries';

export const MY_AD_PROMOTION_STATUS_FIELDS = gql`
  fragment MyAdPromotionStatusFields on Ad {
    id
    vippedUntil
    featuredUntil
  }
`;

export const GET_MY_ADS_LIST = gql`
  ${AD_BASE_FIELDS}
  ${MY_AD_PROMOTION_STATUS_FIELDS}
  query GetMyAdsList(
    $status: CurrentUserAdStatusEnum
    $first: Int
    $after: String
  ) {
    currentUserAds(status: $status, first: $first, after: $after) {
      nodes {
        ...AdBaseFields
        editLockedUntil
        isPayFromBundleAvailable
        ...MyAdPromotionStatusFields
        category {
          name
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

export const GET_CURRENT_USER_COUNTERS = gql`
  query GetCurrentUserCounters {
    currentUserCounters {
      archived
      awaitingPayment
      expired
      pending
      published
      rejected
    }
  }
`;

export const GET_MY_AD_DELETE_REASONS = gql`
  query GetMyAdDeleteReasons($id: ID!) {
    node(id: $id) {
      ... on Ad {
        id
        deleteReasons {
          id
          name
          descriptionRequired
        }
      }
    }
  }
`;

export const GET_MY_AD_SERVICES = gql`
  query AdServices($adId: ID!) {
    adServices(adId: $adId) {
      bumpServices {
        period
        price
        previousPrice
      }
      featuredServices {
        period
        price
        previousPrice
      }
      vipServices {
        period
        price
        previousPrice
      }
    }
  }
`;

export const GET_BULK_PROMOTION_SERVICE_OPTIONS = gql`
  query PaymentServiceOptions($targetIds: [ID!]!) {
    paymentServiceOptions(targetIds: $targetIds) {
      serviceType
      title
      options {
        serviceId
        name
        amount
        default
      }
    }
  }
`;
